import { Logo } from '@/components/brand/logo'

export function FullPageLoader() {
  return (
    <div className="grid min-h-svh place-items-center" role="status" aria-label="Loading">
      <Logo markOnly className="size-8 animate-pulse" />
    </div>
  )
}
